<template>
    <transition name="fade" appear>
      <div class="c-popup" v-show="modal">
        <div class="c-popup__bg"></div>
        <div class="c-popup__inner">
          <div class="closeLayer" @click="emit('close-layer')"></div>
          <div class="c-popup-body">
            <div class="c-popup-body__inner">
              <div class="c-popup-body__main">
                <div class="c-popup-body__head">
                    <p class="c-popup-body__head-title">
                        問題の誤り・不具合を報告しますか？
                    </p>
                </div>
                <div class="c-popup-body__titleBox">
                    <div class="c-popup-body__titleBox-logout">
                        以下のボタンを押すと，別のタブで報告フォームを表示します。
                    </div>
                </div>
              </div>
              <div class="c-popup-body__footer">
                <div class="btnBlock">
                    <button-blue @click="gotoReportPage()" :medium="true" :label-normal="true">報告フォームを表示する</button-blue>
                    <div class="c-button -right">
                        <button-white :no-icon="true" @click="emit('close')">閉じる</button-white>
                    </div>
                </div>
              </div>
              <span class="c-popup-body__close" @click="emit('close')">
              <span class="c-popup-body__close-inner"></span>
            </span>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script setup lang="ts">
  import {ref, onMounted, computed} from "vue"
  import {SUBJECTFIELD_MAP} from "@/consts/subject";

  const appversion = ref(window.document.getElementById("app_version").innerHTML);
  const props = withDefaults(
    defineProps<{
      modelValue?: boolean;
      subject:string;  // learning subject name
      sid:string;  // its learning page which are between S3-7, S3-8 and S3-9
      qid:string;  // work_id and question_id combined together '<work_id>-<question_id>'
      uid: string; // user_id in format 'user <id>'
      workname: string; // selected work name
      qcode: string; // learning question code
      ucid: string; // classroom id
      usid: string; // school id
    }>(),
    {
      modelValue: false,
    }
  );

  const emit = defineEmits<{
    (e: 'close'): void,
    (e: 'close-layer'): void,
  }>()

  
  onMounted(() => {
    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  })

  const modal = computed(() => {
    const body = document.body;
    if (props.modelValue) { // モーダルが開いたとき背景をスクロールした位置で固定にしてスクロールできないようする。
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    } else {
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
    return props.modelValue
  })
  
  function gotoReportPage(): void{
    const ua = window.navigator.userAgent;
    let subject = SUBJECTFIELD_MAP[props.subject]
    const checkdigit = Array.from(`${subject},${props.sid},${props.qid},${props.uid},${ua},${props.workname},${props.qcode},${appversion.value},${props.ucid},${props.usid}`).reduce((x,v)=>x^v.charCodeAt(0),0);
    const url = `https://docs.google.com/forms/d/e/1FAIpQLScVJSIemTZmbGmO7Juty52eWfU73WiKA-elai9dHBAu8ZprIA/viewform?usp=pp_url&entry.702060231=${subject}&entry.1629944145=${encodeURIComponent(props.workname)}&entry.1822623747=${props.sid}&entry.838998088=${props.qid}&entry.445597223=${props.qcode}&entry.161175451=${encodeURIComponent(props.uid)}&entry.1433711376=${encodeURIComponent(appversion.value)}&entry.192388067=${encodeURIComponent(props.ucid)}&entry.1413718947=${encodeURIComponent(props.usid)}&entry.114506989=${encodeURIComponent(ua)}&entry.1976863075=${checkdigit}`
    window.open(url);
  }
</script>